var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.97644V15.5059",
    stroke: "#054BC7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 21.5293C14.8317 21.5293 15.5059 20.8551 15.5059 20.0235C15.5059 19.1918 14.8317 18.5176 14 18.5176C13.1683 18.5176 12.4941 19.1918 12.4941 20.0235C12.4941 20.8551 13.1683 21.5293 14 21.5293Z",
    fill: "#054BC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 26.8C21.0694 26.8 26.8002 21.0692 26.8002 14C26.8002 6.93071 21.0694 1.19995 14.0002 1.19995C6.93095 1.19995 1.2002 6.93071 1.2002 14C1.2002 21.0692 6.93095 26.8 14.0002 26.8Z",
    stroke: "#054BC7",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation_mark.2b61229235147a562b7006b6a3b4dccc.svg";
export { ForwardRef as ReactComponent };